import React from 'react';
import Heading from '@hubins/components/Heading';
import SimpleTable from 'modules/Tables/SimpleTable';
import ShowRawResponse from './ShowRawResponse';
const tableHeaders = [
  {
    Header: '',
    accessor: 'type'
  },
  {
    Header: '',
    accessor: 'value'
  },

]

const SanctionsTemplate = ({ screening }) => {
  return (
    <>
      <div className='flex flex-direction-row space-between align-items-center s-bottom-l'>
        <Heading className='s-top-l' size="4">Hits: <span className={` ${screening.result.hitCount > 0 ? 'c-danger' : 'c-success'}`}>{screening.result.hitCount}</span></Heading>
        <ShowRawResponse screening={screening} />
      </div>
      {(screening?.result?.hits && Array.isArray(screening.result.hits)) ? screening.result.hits.map((hit) => {
        return (
          <div className='s-bottom-l'>
            <SimpleTable
              headers={tableHeaders}
              data={[
                {
                  type: 'Sanction organisation',
                  value: hit?.sanctionsOrganisation ? hit.sanctionsOrganisation : 'N/A'
                },
                {
                  type: 'Search score',
                  value: hit?.searchScore ? hit.searchScore : 'N/A'
                },
                {
                  type: 'Birth dates',
                  value: hit?.birthDates ? hit.birthDates.map((birthDate) => `${birthDate.birthDate}`).join(', ') : 'N/A'
                },
                {
                  type: 'Countries',
                  value: hit?.countries ? hit.countries.map((country) => `${country.country}`).join(', ') : 'N/A'
                },
                {
                  type: 'Entity type',
                  value: hit?.entityType ? hit.entityType : 'N/A'
                },
                {
                  type: 'Genders',
                  value: hit?.genders ? hit.genders.map((gender) => `${gender.gender}`).join(', ') : 'N/A'
                },
                {
                  type: 'Names',
                  value: Array.isArray(hit?.sanctionsListsDetails) ? hit?.sanctionsListsDetails.map((list) => list.names.map((name) => `${name.firstName || ''} ${name.lastName || ''}`).join(', ')).join(', ') : 'N/A'
                },
              ]}
            />
          </div>
        )
      }) : <p>No hits found</p>}
    </>
  )
};

export default SanctionsTemplate;